import { linear, parseEasingFunction } from '../utils/animation';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming
 */

var AnimationEffectTiming =
/** @class */
function () {
  function AnimationEffectTiming() {
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/delay
     */
    this.delay = 0;
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/direction
     */

    this.direction = 'normal';
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/duration
     */

    this.duration = 'auto';
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/easing
     */

    this._easing = 'linear';
    this.easingFunction = linear;
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/endDelay
     */

    this.endDelay = 0;
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/fill
     */

    this.fill = 'auto';
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/iterationStart
     */

    this.iterationStart = 0;
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/iterations
     */

    this.iterations = 1;
    this.currentIteration = null;
    this.progress = null;
  }

  Object.defineProperty(AnimationEffectTiming.prototype, "easing", {
    get: function get() {
      return this._easing;
    },
    set: function set(value) {
      this.easingFunction = parseEasingFunction(value);
      this._easing = value;
    },
    enumerable: false,
    configurable: true
  });
  return AnimationEffectTiming;
}();

export { AnimationEffectTiming };